import { type PauseDto } from "@modules/common/pauseObject/gateway/pauseApiDto"

export class PauseEntity {
  pausedAt: Date
  resumeAt: Date | null
  programAccessAllowed: boolean

  constructor(pauseEntity: PauseEntity) {
    this.pausedAt = pauseEntity.pausedAt
    this.resumeAt = pauseEntity.resumeAt
    this.programAccessAllowed = pauseEntity.programAccessAllowed
  }

  static fromDto(pauseDto: PauseDto): PauseEntity {
    return new PauseEntity({
      pausedAt: new Date(pauseDto.pausedAt),
      resumeAt: pauseDto.resumeAt ? new Date(pauseDto.resumeAt) : null,
      programAccessAllowed: pauseDto.programAccessAllowed,
    })
  }
}
